"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlavorText = function FlavorText(props) {
  var text = props.text;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      margin: '2rem 0'
    }
  }, /*#__PURE__*/_react.default.createElement("p", {
    style: {
      fontFamily: '"Roboto", "sans-serif"',
      fontWeight: 'normal',
      fontSize: '16px',
      color: '#000',
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("em", null, text)));
};

var _default = FlavorText;
exports.default = _default;